import { useState } from "react";
import Detail from "../Components/Detail";
import Footer from "../Components/Footer";
import NavBackground from "../Components/Navbar";
import { useCustomQuery } from "../config/query";
import { User } from "../utils/profile";

const Detailtour = () => {
  const [profile, setProfile] = useState();
  let { data } = useCustomQuery("profile", User);

  return (
    <div style={{ background: "#e5e5e5" }}>
      <NavBackground data={data} />
      <Detail />

      <Footer />
    </div>
  );
};

export default Detailtour;
